import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import NumberFormat from "react-number-format";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import LinearProgress from "@material-ui/core/LinearProgress";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";
import {InputSwitch} from "primereact/inputswitch";
import ContextMenu from "../../../components/contextMenu";
const ContingencyTrustBbvaView = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Contingencia Fideicomiso BBVA"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchContingency}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Folio" isBold={true}/>
                                    <NumberFormat
                                        name="folioFilter"
                                        thousandSeparator={false}
                                        placeholder="Ex. 1000"
                                        onChange={props.onChangeFilter}
                                        value={props.folioFilter}
                                        customInput={InputText}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Contraparte" isBold={true}/>
                                    <Dropdown
                                        name="catInstitutionFilter"
                                        filter={true}
                                        filterBy="institutionName"
                                        options={props.catInstitution}
                                        optionLabel="institutionName"
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeFilter}
                                        value={props.catInstitutionFilter}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Tipo instrucción" isBold={true}/>
                                    <Dropdown
                                        name="catInstructionTypeFilter"
                                        filterBy="instructionName"
                                        options={props.catInstructionType}
                                        optionLabel="instructionName"
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeFilter}
                                        value={props.catInstructionTypeFilter}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Estatus" isBold={true}/>
                                    <Dropdown
                                        name="catStatusFilter"
                                        filter={true}
                                        filterBy="statusName"
                                        options={props.catStatus}
                                        optionLabel="statusName"
                                        placeholder="Seleccione..."
                                        onChange={props.onChangeFilter}
                                        value={props.catStatusFilter}/>
                                </div>
                                <div className="p-col-12 p-md-12 p-col-12">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12} >
                        <div className="p-grid p-align-center p-justify-end">
                            <div className="p-col-12 p-md-1 p-lg-7"/>
                            <div className="p-col-12 p-md-4 p-lg-2" >
                                <SubtitleLabel header="Liquidación manual" isBold={true} align={'right'}/>
                                <InputSwitch name="manualSettle" checked={props.manualSettle} style={{'float': 'right'}}
                                             onChange={props.onChangeSwitch}/>
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-2">
                                <Button type="button"
                                        iconPos="left"
                                        label="Actualizar instituciones"
                                        style={{'float': 'right'}}
                                        onClick={props.openConfirmationMessageUpdateInst}
                                        className="p-button-secondary"
                                        hidden={true}/>
                            </div>
                            <div className="p-col-12 p-md-3 p-lg-1" style={{textAlign: 'right'}}>
                                <ContextMenu menuOptions={props.exportOptions}
                                             isButton={true}
                                             label="Exportar"/>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.contingencyInstructions}
                            responsive={true}
                            selection={props.selectedInstruction}
                            onSelectionChange={props.selectRowInstruction}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column selectionMode="multiple" style={{width: '3em'}}/>
                            <Column field="loanId" header="Folio" sortable={true}/>
                            <Column field="referencePv" header="Referencia Presval" sortable={true}/>
                            <Column field="instrumentSerialName" header="Emisora" sortable={true}/>
                            <Column field="titles" header="Títulos" body={numberWithCommaDataTableTemplate}
                                    sortable={true}/>
                            <Column field="eventType" header="Tipo de Instrucción" sortable={true}/>
                            <Column field="origin" header="Origen" sortable={true}/>
                            <Column field="originAccount" header="Cuenta Origen" sortable={true}/>
                            <Column field="destiny" header="Destino" sortable={true}/>
                            <Column field="destinyAccount" header="Cuenta Destino" sortable={true}/>
                            <Column field="status" header="Estatus" sortable={true} body={props.errorTemplate}/>
                            <Column field="trustReference" header="Referencia BBVA" sortable={true}/>
                            <Column field="modifyBy" header="Usuario" sortable={true}/>
                            <Column field="modify" header="Hora" sortable={true}/>
                            <Column field="action" header="Trazabilidad" sortable={true}/>
                            <Column header="Acciones"
                                    body={props.actionsTemplate}
                                    style={{textAlign: 'center', width: '8em'}}/>
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                    {props.confMsgUpdateInst}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ContingencyTrustBbvaView;